import { FC, useCallback, useState } from "react";
import { createContext } from "use-context-selector";
import SendLinkModal from "../components/Modals/SendLinkModal";

export type SendLinkModalContextType = {
  handleOpenSendLinkModal: () => void;
};

export const SendLinkModalContext = createContext(
  {} as SendLinkModalContextType
);

export const SendLinkModalProvider = ({ children }: { children: any }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOpenSendLinkModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <SendLinkModalContext.Provider value={{ handleOpenSendLinkModal }}>
      {children}
      <SendLinkModal opened={isOpen} handleClose={handleClose} />
    </SendLinkModalContext.Provider>
  );
};
